import { render, staticRenderFns } from "./MasterDataYG.vue?vue&type=template&id=01fb8422&scoped=true"
import script from "./MasterDataYG.vue?vue&type=script&lang=js"
export * from "./MasterDataYG.vue?vue&type=script&lang=js"
import style0 from "./MasterDataYG.vue?vue&type=style&index=0&id=01fb8422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb8422",
  null
  
)

export default component.exports